import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../features/auth/authSlice';

/**
 * Session Expired Handler Component
 * Automatically redirects to login page when session expires
 */
const SessionExpiredModal = () => {
  const { sessionExpired } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Auto-logout and redirect when session expires
  useEffect(() => {
    if (sessionExpired) {
      // Dispatch logout action to clear auth state
      dispatch(logOut());
      // Redirect to login page
      navigate('/');
    }
  }, [sessionExpired, dispatch, navigate]);
  
  // This component doesn't render anything - it just handles the redirect
  return null;
};

export default SessionExpiredModal;
